export default "__VITE_ASSET__CBde7Trc__"